import React, { lazy } from 'react';
import { CheckCircle2 } from 'lucide-react';
const POINTS = ['Entry door glass replacement', 'Patio door and sliding door glass', 'Storm door glass', 'Decorative and patterned glass inserts', 'Interior door glass', 'Safety glass options when required'];
export function DoorGlass() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-slate-50 border-t border-slate-200" data-id="element-1240">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1241">
        <div className="anim-on-scroll" data-id="element-1242">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-1243">
            Door Glass, Patio Door Glass & Decorative Inserts
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-1244">
            Kosin's Glass repairs and replaces residential door glass, including
            entry doors, patio doors, storm doors, interior doors and decorative
            glass inserts. Whether the glass is broken, foggy, outdated or no
            longer fits your style, the team can help measure and recommend
            replacement options.
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-1245">
            {POINTS.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-1246">
                <CheckCircle2 className="w-5 h-5 text-brandBlue-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-1247" />
                <span className="text-slate-700 font-medium" data-id="element-1248">{point}</span>
              </li>)}
          </ul>
          <a href="#estimate-form" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-1249">
            Get a Door Glass Estimate
          </a>
        </div>
        <div className="rounded-2xl aspect-video lg:aspect-square w-full overflow-hidden shadow-card anim-on-scroll" data-id="element-1250">
          <img src="https://cdn.magicpatterns.com/uploads/9XxbdWLs6PpWxkz1WJRiW1/door.png" alt="Kosin's Glass technician measuring a residential entry door with decorative glass insert" className="w-full h-full object-cover" loading="lazy" data-id="element-1251" />
        </div>
      </div>
    </section>;
}